import * as analytics from './analytics';
import * as config from './config';
import * as app from './app';
import * as launch from './launch';
import * as iwa from './iwa';
import * as kv from './kv';
import * as userfiles from './userfiles';
export default {
    analytics: analytics,
    config: config,
    app: app,
    launch: launch,
    iwa: iwa,
    kv: kv,
    userfiles: userfiles,
};
//# sourceMappingURL=index.js.map